import { render, staticRenderFns } from "./ModalViewDocument.vue?vue&type=template&id=0002665b&"
import script from "./ModalViewDocument.vue?vue&type=script&lang=js&"
export * from "./ModalViewDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports